import { useQuery } from 'react-query';

import { getStoredTags as queryFn } from 'api/endPoints/getStoredTags';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetStoredTags = (params: QueryParams) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getStoredTags', params],
        queryFn: () => queryFn(params),
        enabled: params.enabled && Boolean(params.customerId) && Boolean(params.projectId),
    });
};

export interface QueryParams {
    enabled: boolean;
    customerId?: number;
    projectId?: number;
    contractId?: number;
}

interface QueryResponse {
    count: number;
    name: string;
    tagId: number;
    projectId: number;
    projectName: string | null;
}
